import { css } from '@emotion/react'

const messageCard = css`
  a {
    text-decoration: none;
  }
  .header {
    font-weight: 600;
  }
`

// First rule is removal of the hover effect, which is not controlled via a prop
const table = css`
  tr:hover {
    background-color: inherit !important;
    td:first-of-type {
      border-left-color: transparent !important;
    }
  }
`

export const styles = {
  messageCard,
  table,
}
